import React from 'react';
import { AlertTriangle, FileSearch, ListChecks, LucideIcon } from 'lucide-react';
import { RobbieMark } from '../../ui';

/**
 * The "Robbie will:" strip from `design/RFQ Wizard v2.dc.html`. Robbie
 * attribution is the RobbieMark mascot (xs — the mock's 28×18 geometry),
 * never a text tag. AI-carrying container → ai-panel wash + robbie border;
 * icons are the only violet. Defaults to the wizard Step 1 items; pages with
 * a different promise (e.g. the datasheet library) pass their own.
 */

export interface RobbieWillItem {
  icon: LucideIcon;
  label: string;
}

const ITEMS: readonly RobbieWillItem[] = [
  { icon: ListChecks, label: 'Extract components & quantities' },
  { icon: FileSearch, label: 'Cross-reference documents' },
  { icon: AlertTriangle, label: 'Flag missing fields' },
];

export const RobbieWillStrip: React.FC<{ items?: readonly RobbieWillItem[] }> = ({ items = ITEMS }) => (
  <div className="flex flex-wrap items-center gap-x-s7 gap-y-s3 rounded-card border border-robbie-border bg-ai-panel px-[18px] py-[14px]">
    <div className="flex shrink-0 items-center gap-s3">
      <RobbieMark size="xs" aria-label="Robbie" />
      <span className="text-[12.5px] font-bold text-ink">Robbie will:</span>
    </div>
    {items.map(({ icon: Icon, label }) => (
      <div key={label} className="flex items-center gap-[7px] text-[12.5px] text-ink-body">
        <Icon className="h-[14px] w-[14px] shrink-0 text-robbie" />
        {label}
      </div>
    ))}
  </div>
);

export default RobbieWillStrip;
